import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiCopyToClipBoardWrapper = styled.div`
  display: flex;
  width: 100%;

  .value-style {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
  }
  .clipboard-value {
    max-width: 80%;
  }
  .copy-button {
    color: ${COLORS.primary_light_blue};
    padding: 0;
    margin-left: 10px;

    .check-icon {
      fill: ${COLORS.cirrus_black7};
    }
  }
`;
